import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Image, Descriptions, Typography, List } from 'antd';
import { useParams, useLocation, Link } from 'react-router-dom';
import Loading from 'components/Loading';
import { getProduct } from 'requests/product';
import PageTitle from 'components/PageTitle';
import Parse from 'html-react-parser';

const { Title } = Typography;

function ProductDetail(props) {
	const [titles, setTitles] = useState([{ path: '/products', title: 'Products' }]);
	const [product, setProduct] = useState({});
	const [loading, setLoading] = useState(true);

	const params = useParams();
	const location = useLocation();

	useEffect(() => {
		const getData = async () => {
			const productDetail = await getProduct(params.id);

			setTitles([
				{ path: '/products', title: 'Products' },
				{ path: location.pathname, title: productDetail.name },
			]);
			setProduct(productDetail);
			setLoading(false);
		};

		getData();
	}, []);
	return (
		<div>
			<PageTitle titles={titles} />
			{loading ? (
				<Loading />
			) : (
				<Row gutter={[16, 16]} className="mb-36 mt-36">
					<Col xs={24} sm={24} md={14} lg={14}>
						<Card>
							<Row gutter={[16, 16]}>
								<Col xs={24} sm={24} md={10}>
									<Image
										src={product.image || 'error'}
										width="100%"
										height="100%"
										fallback="data:image/png;base64,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"
									/>
								</Col>
								<Col xs={24} sm={24} md={14}>
									<Descriptions column={1} size="small" layout="horizontal">
										<Descriptions.Item label="ID">{product.id}</Descriptions.Item>
										<Descriptions.Item label="Platform Product ID">
											{product.platform_product_id}
										</Descriptions.Item>
										<Descriptions.Item label="SKU">{product.sku}</Descriptions.Item>
										<Descriptions.Item label="Weight">{product.weight}kg</Descriptions.Item>
										<Descriptions.Item label="Height">{product.height}cm</Descriptions.Item>
										<Descriptions.Item label="Width">{product.width}cm</Descriptions.Item>
										<Descriptions.Item label="Length">{product.length}cm</Descriptions.Item>
										<Descriptions.Item label="HNS">{product.hns}</Descriptions.Item>
										<Descriptions.Item label="Price">{product.store?.currency} {product.price}</Descriptions.Item>
									</Descriptions>
								</Col>
							</Row>
						</Card>
						{product.description ? (
							<Card className="mt-24">
								<Title level={5} className="text-gray">
									Descriptions
								</Title>
								<div>{Parse(product.description)}</div>
							</Card>
						) : null}
					</Col>

					<Col xs={24} sm={24} md={8} lg={8}>
						<Card>
							<Title level={5} className="text-gray">Store</Title>
							<div>
								<Link to={`/stores/${product.user_store_id}`}>{product.store?.store_name}</Link>
							</div>
						</Card>
						{product.variations.length > 0 && (
							<Card className="mt-24">
								<Title level={5} className="text-gray">
									Variations
								</Title>
								<List
									size="small"
									dataSource={product.variations}
									renderItem={(item, index) => {
										const options = item.options.map(option => `${option.name}: ${option.value}`);

										return (
											<List.Item>
												<div>
													<strong>{`Variation ${index + 1} `}</strong>
													<div>
														<small>{options.join(' - ')}</small>
													</div>
													<div>
														<small>{item.defaultDisplayedPriceFormatted}</small>
													</div>
												</div>
											</List.Item>
										)
									}}
								/>
							</Card>
						)}
					</Col>
				</Row>
			)}
		</div>
	);
}

export default ProductDetail;
